var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-main"},[_c('headerWorld'),_c('div',{staticClass:"user-center-content"},[_c('div',{staticClass:"left-nav"},[_c('homeWorkCircleNav')],1),_c('div',{staticClass:"right-content"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }